import React from 'react';
const links = ['Política de Privacidad', 'Términos y Condiciones', 'Contacto'];
export function Footer() {
  return <footer className="w-full bg-forest-ink py-8" data-id="element-85" data-mp="3ggaqtvj9sd5g">
      <div className="mx-auto flex max-w-4xl flex-col items-center px-5 text-center sm:px-6" data-id="element-86" data-mp="3gh3sii3dgcgq">
        <p className="text-lg font-bold text-gold" data-id="element-87" data-mp="32m1awxp5wyo3">Legado Salud</p>

        <ul className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-2" data-id="element-88" data-mp="36pzb7bq84fiq">
          {links.map(link => <li key={link} data-id="element-89" data-mp="3uftmvpyt3y1e">
              <a href="#" className="text-xs text-white/50 underline-offset-4 transition-colors duration-150 ease-out hover:text-white/80 hover:underline" data-id="element-90" data-mp="38qvoyiyxrr6">
                {link}
              </a>
            </li>)}
        </ul>

        <p className="mt-4 max-w-[600px] text-[11px] leading-relaxed text-white/40" data-id="element-91" data-mp="3qcx8kbgauo39">
          Los resultados individuales pueden variar. Este producto es de naturaleza informativa y
          educativa. No reemplaza el diagnóstico ni el consejo médico profesional. Consulta a tu
          médico antes de iniciar cualquier protocolo de salud.
        </p>
      </div>
    </footer>;
}